import {
  ChangeDetectorRef, Input, Output, Component, ViewChild, OnDestroy,
  EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';

import { DropdownDirective } from 'shared/dropdown/dropdown.directive';

interface ScorecardItem {
  _id: string;
  name: string;
  unique_id: string;
  image: string;
  default: boolean;
}

@Component({
  moduleId: module.id,
  selector: 'scorecard-dropdown',
  templateUrl: 'scorecard-dropdown.component.html',
  styleUrls: ['scorecard-dropdown.component.scss'],
})
export class ScorecardDropdownComponent implements OnDestroy {

  @Input() items: Array<ScorecardItem> = [];
  @Input() color: string = 'white';
  @Input() showSelected: boolean = true;
  @Input() disabled: boolean = false;

  @Output() selectedChange = new EventEmitter<any>();

  selectedItem: any;

  noCompletionItem: any = {
    name: 'Completion Off',
    image: 'assets/svg/scorecard/turn-off-icon.svg',
    _id: 'off',
  };

  firstItems: Array<string> = [
    'pies-70',
    'pies-67',
    'sdc-platinum',       // SEMA Data Excellence
    'partshub-starter',   // SEMA Data Silver
    'pies-72',
  ];
  deprecatedItems: Array<string> = [
    'pies-65',
  ];
  hiddenItems: Array<string> = [
    'pies-71',
  ];

  @ViewChild(DropdownDirective, {static: false})
  dropdownWrap: DropdownDirective | void;

  constructor(private ref: ChangeDetectorRef) {}

  get filteredItems(): Array<ScorecardItem> {
    const filtered: Array<ScorecardItem> = this.items
      .filter(i => !this.deprecatedItems.includes(i.unique_id))
      .filter(i => !this.hiddenItems.includes(i.unique_id));
    const availableIds = filtered
      .map(i => i.unique_id);
    const sortedIds = this.firstItems
      .filter(i => availableIds.includes(i));
    const restIds = availableIds
      .filter(i => !sortedIds.includes(i));
    const ids = sortedIds.concat(restIds);

    return ids
      .map(id => filtered.find(item => item.unique_id === id));
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

   public selectScorecardById(_id: string) {
     if (_id === 'off') {
       this.selectedItem = this.noCompletionItem;
     } else {
       // @ts-ignore
         this.selectedItem = _.find(this.items, {_id});
     }
     this.ref.markForCheck();
   }

   public isActive(item: any) {
     return _.get(item, '_id') === _.get(this.selectedItem, '_id');
   }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnDestroy() {
    this.items = [];
    this.selectedItem = null;
    this.ref.markForCheck();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onDropdownItemClick(item: any) {
    this.selectedItem = item;
    this.selectedChange.emit(item);
    if (this.dropdownWrap instanceof DropdownDirective) {
      this.dropdownWrap.close();
    }
    this.ref.markForCheck();
  }

  itemImage(item: any) {
    const now = new Date();
    const hourlySuffix = now.setMinutes(0, 0, 0);
    return item.image ? `${item.image}?v=${hourlySuffix}` : '';
  }
}
